<template>
  <div class="footer">
  	<div class="foot">
  		<p>{{$t('m.common.footerTest')}}</p>
  	</div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import header from './header.vue'  
export default {
	name: 'footerDIV',
	data () {
	    return {
	      
	    }
  	}
}
</script>

<style scoped>
	.foot{
		width: 100%;
		height: 40px;
		font-size:14px;
		position: fixed;
		left: 0;
		bottom: 0;
		z-index: 1000;
		font-weight:600;
		color:#999;
		line-height:14px;
		background-color: #F2F2F2;
	}
	.foot p{
		width: 1180px;
		height: 40px;
		margin:0 auto;
		display: flex;
		justify-content: center;
		align-items: center;
	}
</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue